export const handleHttpResponse = async (response) => {
  if (response.status === 401) {
    alert("Authentication Expired");
    return window.location.reload();
  }
  if (response.status === 403) {
    const errorRes = await response.json();
    if (errorRes.roles.includes("force_password_change")) {
      alert(errorRes.msg);
      return window.open("/settings", "_self");
    } else {
      console.log(errorRes);
      return errorRes;
      // return window.open("/dashboard", "_self");
    }
  }
  return response;
};
